import { defineMessages } from 'react-intl'

export default defineMessages({
  submit: {
    id: 'components.Button.submit',
    defaultMessage: 'Submit',
    description: '提交按钮文本',
  },
  pay: {
    id: 'components.Button.pay',
    defaultMessage: 'Pay',
    description: '支付按钮文本',
  },
  back: {
    id: 'components.Button.back',
    defaultMessage: 'Back',
    description: '返回按钮文本',
  },
  refresh: {
    id: 'components.Button.refresh',
    defaultMessage: 'Refresh',
    description: '返回按钮文本',
  },
})
